import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n

import '@/styles/index.scss' // global css

import App from './App'
import VueAuthHref from 'vue-auth-href'
import store from './store'
import router from './router'

import '@/icons' // icon 
import '@/permission' // permission control
import qs from 'qs';
import axios from 'axios';
import domain from '@/api/api_url.js';
import Cookies from 'js-cookie'

import md5 from 'js-md5'

import Video from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Video //引入Video播放器


import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import htmlToPdf from '@/utils/htmlToPdf'
Vue.use(htmlToPdf)



Vue.prototype.axios = axios;
axios.defaults.baseURL = domain.domain;
// 添加请求拦截器，在请求头中加token
axios.interceptors.request.use(
  config => {
    if (localStorage.getItem('Authorization')&&localStorage.getItem('Authorization')!='undefined') {
      config.headers.Authorization = localStorage.getItem('Authorization');
    }else{
      config.headers.Authorization = Cookies.get('Authorization');
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  });


Vue.prototype.$qs = qs;
Vue.prototype.$md5 = md5;
Vue.directive('focus', function (el) {
  el.querySelector('input').focus()
})


// Vue.directive('focus',{
//   bind:function(el){
//     el.querySelector('input').focus()
//   },
//   updated:function(el){
//     el.querySelector('input').focus()
//   },
//   inserted:function(el){
//     el.querySelector('input').focus()                         
//   },
//   })

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
if (process.env.NODE_ENV === 'production') {
  // const { mockXHR } = require('../mock')
  // mockXHR()
}

// set ElementUI lang to EN
Vue.use(ElementUI)
// var auth2=store.state["Authorization"]

const options = {
  token: () => store.state["Authorization"].slice(7)||Cookies.get('Authorization').slice(7), // Note that this MUST BE a function that returns the token.
  // other options here (full list of options described below)
}
// console.log(options,"options")
Vue.use(VueAuthHref, options)
// Vue.use(CKEditor)
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)
// import echarts from 'echarts'
import * as echarts from "echarts"
// import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
